module.exports = __webpack_public_path__ + "media/images/expand-button-08ce7b82f92c9b5aa4b7a0f8e52c0bc9.svg";